import Image from 'next/image';

import { Flex } from '@chakra-ui/react';

const AWARDS = [
  {
    src: '/images/about-us/awards/career-launching-company.png',
    alt: 'Career Launching Company award',
    width: 80,
    height: 80,
    mobileOrder: 6,
  },
  {
    src: '/images/about-us/awards/brandon-hall.png',
    alt: 'Brandon Hall award',
    width: 113,
    height: 80,
    mobileOrder: 1,
  },
  {
    src: '/images/about-us/awards/edtech-awards.png',
    alt: 'EdTech Awards',
    width: 138,
    height: 64,
    mobileOrder: 3,
  },
  {
    src: '/images/about-us/awards/g2-leader.png',
    alt: 'G2 Leader award',
    width: 71,
    height: 80,
    mobileOrder: 4,
  },
  {
    src: '/images/about-us/awards/customer-service-award.png',
    alt: 'Customer Service award',
    width: 87,
    height: 80,
    mobileOrder: 2,
  },
  {
    src: '/images/about-us/awards/cnbc-disruptor-50.png',
    alt: 'CNBC Disruptor 50 2023',
    width: 217,
    height: 56,
    mobileOrder: 5,
  },
] as const;

export function AboutUsAwardsSection() {
  return (
    <Flex
      alignItems='center'
      as='section'
      bg='white'
      borderBottom='1px solid'
      borderBottomColor='#F2F2F2'
      flexWrap={{ base: 'wrap', lg: 'nowrap' }}
      gap={{ base: 8, lg: 0 }}
      justifyContent={{ base: 'center', lg: 'space-between' }}
      maxW='1440px'
      mx='auto'
      px={{ base: 4, lg: '80px' }}
      py={{ base: 8, lg: '40px' }}
      width='full'
    >
      {AWARDS.map((award) => (
        <Flex key={award.src} alignItems='center' order={{ base: award.mobileOrder, lg: 0 }} shrink={0}>
          <Image
            alt={award.alt}
            draggable={false}
            height={award.height}
            src={award.src}
            style={{ objectFit: 'contain' }}
            width={award.width}
          />
        </Flex>
      ))}
    </Flex>
  );
}
